"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Debounce = exports.useDebounce = void 0;
var react_1 = __importDefault(require("react"));
function useDebounce(timeout, behavior) {
    if (timeout === void 0) { timeout = 300; }
    if (behavior === void 0) { behavior = 'ignore'; }
    var timeoutRef = react_1["default"].useRef(null);
    var onTimeoutRef = react_1["default"].useRef();
    return react_1["default"].useCallback(function (fn) {
        onTimeoutRef.current = fn;
        if (timeoutRef.current !== null) {
            if (behavior === 'ignore') {
                return;
            }
            else {
                clearTimeout(timeoutRef.current);
            }
        }
        timeoutRef.current = setTimeout(function () {
            timeoutRef.current = null;
            if (onTimeoutRef.current != null)
                onTimeoutRef.current();
        }, timeout);
    }, [timeout]);
}
exports.useDebounce = useDebounce;
var Debounce = /** @class */ (function () {
    function Debounce(timeout, behavior) {
        if (timeout === void 0) { timeout = 300; }
        if (behavior === void 0) { behavior = 'ignore'; }
        var _this = this;
        this.timeout = timeout;
        this.behavior = behavior;
        this.timeoutRef = null;
        this.onTimeoutRef = null;
        this.run = function (fn) {
            _this.onTimeoutRef = fn;
            if (_this.timeoutRef !== null) {
                if (_this.behavior === 'ignore') {
                    return;
                }
                else {
                    clearTimeout(_this.timeoutRef);
                }
            }
            _this.timeoutRef = setTimeout(function () {
                _this.timeoutRef = null;
                if (_this.onTimeoutRef != null)
                    _this.onTimeoutRef();
            }, _this.timeout);
        };
    }
    return Debounce;
}());
exports.Debounce = Debounce;
